import { environment } from '@env/environment';

export const STORAGE_SSO = environment.localStorageName + '_from_sso';

// Policies currently apply to every application; per-application scopes may follow later.
export const POLICY_SCOPE_ALL = 'ALL';
